<template>
  <div class="push-list-view page-background-new">
    <DateSelectorView
      @dateSelected="confirmPicker"
      style="margin:1rem;background-color:white"
    />
    <div v-for="(item, index) in list" :key="index" class="push-list-view-item">
      <div style="margin:0 1rem">
        推送日期:<span>{{ item.pushDate }}</span>
      </div>
      <div style="margin:.5rem 1rem;">
        推送频率:<span>{{ item.frequency }}</span>
      </div>
      <div style="display:flex;margin:.5rem 1rem;">
        <div style="min-width:5rem">推送内容:</div>
        <div style="color:#333">{{ item.context }}</div>
      </div>
      <div class="push-list-view-item-bottom">
        <div
          style="color:#FE5546;border-right: 1px solid #efefef;"
          @click="delteClick(item)"
        >
          删除
        </div>
        <div style="color:#09f" @click="changeClick(item)">修改</div>
      </div>
    </div>
    <div class="push-list-view-btn" @click="goAddpush()">新增推送</div>
  </div>
</template>

<script>
import DateSelectorView from "./DateSelectorView.vue";

export default {
  components: {
    DateSelectorView
  },
  data() {
    return {
      content: "",
      startDate: new Date(),
      endDate: new Date(),
      list: []
    };
  },

  created() {
    this.startDate = this.$moment()
      .add(-3, "month")
      .toDate();
    this.endDate = this.$moment()
      .add(3, "month")
      .toDate();
    this.startDate = this.$moment(this.startDate).format("YYYY-MM-DD");
    this.endDate = this.$moment(this.endDate).format("YYYY-MM-DD");
    this.getList();
  },
  methods: {
    goAddpush() {
      this.$router.push({
        name: "push-setting",
        query: {}
      });
    },
    delteClick(item) {
      this.$phdialog
        .confirm({
          message: "确认删除？",
          confirmButtonText: "确认",
          cancelButtonText: "取消"
        })
        .then(() => {
          this.deletepush(item);
        });
    },
    changeClick(item) {
      this.$router.push({
        name: "push-setting",
        query: {
          id: item.id
        }
      });
    },
    deletepush(item) {
      this.$http
        .post(this.$api.PUSH_DELETE, {
          id: item.id,
          qAccesstoken: localStorage.getItem("qAccesstoken")
        })
        .then(res => {
          alert("删除成功");
          this.getList();
        });
    },
    getList() {
      this.$http
        .post(this.$api.PUSH_GET_LIST, {
          startDate: this.startDate,
          endDate: this.endDate,
          qAccesstoken: localStorage.getItem("qAccesstoken")
        })
        .then(res => {
          this.list = res.map(item => {
            let frequency = "";

            switch (item.type) {
              case "0":
                frequency = "仅一次";
                break;
              case "1":
                frequency = "每天一次";
                break;
              case "2":
                frequency = "每周一次";
                break;
              case "3":
                frequency = "每月一次";
                break;
              default:
                break;
            }
            return {
              ...item,
              frequency
            };
          });
        })
        .catch(error => {
          // eslint-disable-next-line no-param-reassign
          if ((error.message = "accessToken过期！")) {
            this.$router.replace({
              name: "push-setting-login"
            });
          }
        });
    },
    confirmPicker(startDate, endDate) {
      this.startDate = this.$moment(startDate).format("YYYY-MM-DD");
      this.endDate = this.$moment(endDate).format("YYYY-MM-DD");
      this.getList();
    }
  }
};
</script>

<style lang="less">
.push-list-view {
  width: 100%;
  height: 90%;
  overflow: scroll;
  &-btn {
    position: absolute;
    bottom: 0.4rem;
    width: calc(100% - 2.66rem);
    margin-left: 1.33rem;
    color: white;
    line-height: 3.33rem;
    text-align: center;
    // line-height: 3.3rem;
    background-color: #09f;
    border-radius: 1.65rem;
  }
  &-item {
    margin: 0 1rem 1rem 1rem;
    padding-top: 1rem;
    font-size: 1rem;
    background: white;
    border-radius: 0.5rem;
    &-bottom {
      display: flex;
      justify-content: space-between;
      margin-top: 1rem;
      line-height: 3rem;
      text-align: center;
      border-top: 1px solid #efefef;
      > div {
        width: 50%;
      }
    }
    > div {
      color: #999;
      > span {
        margin-left: 0.8rem;
        color: #333;
      }
    }
  }
}
</style>
